module.exports = __webpack_public_path__ + "img/appstore-badge.7877fa3b.png";